import { config } from '../config';
import { HttpServices } from '../Helper';

export const DownloadTemplate = async (unitId, templateId) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/DynamicTemplateForm/DownloadTemplate/${unitId}/${templateId}`,
    { responseType: 'blob' }
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const DownloadHtmlTemplate = async (unitId, templateId) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/DynamicTemplateForm/DownloadHtmlTemplate/${unitId}/${templateId}`,
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const UploadPdfFileTemplate = async ({unitId, templateId, unitOperationTypeId}) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/DynamicTemplateForm/UploadPdfFileTemplate/?unitId=${unitId}&templateId=${templateId}&unitOperationTypeId=${unitOperationTypeId}`,
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const AddSendProposalLog = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/DynamicTemplateForm/AddSendProposalLog`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
export const AddShareDocumentLog = async (body, isWhatsAppLog = false) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/ScopeDocument/AddShareDocumentLog?isWhatsAppLog=${isWhatsAppLog}`, body
  )
  .then((data) => data)
  .catch((error) => error.response);
  return result;
}